import React from 'react';

import { Section, preloader } from 'spectacle-ppa';
import videoSlide from '../../baseSlides/videoSlide';

import ianSaraSilly from '../../images/characters/ian_sara_silly.png';
import ianSaraTwoFingers from '../../images/characters/ian_sara_two_fingers.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './song.md';

const md = new MarkdownScript(markdownFile);

export function preloadSong () {
  preloader([
    ianSaraSilly,
    ianSaraTwoFingers
  ]);
}

function songSection ({ regionData }) {
  return (
    <Section id="song">

      {/* Song */}
      {videoSlide({
        id: 'video',
        notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData)
      })}

    </Section>
  );
}

export default songSection;



// WEBPACK FOOTER //
// ./programs/epsPrimaries/sections/03_song/songSection.jsx